var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.219 18.952a5.362 5.362 0 002.453-.094c-2.485-.502-4.362-2.715-4.362-5.367l.001-.07c.735.411 1.573.657 2.463.687A5.479 5.479 0 014.356 9.55c0-1.004.268-1.94.737-2.752 2.681 3.312 6.687 5.489 11.205 5.718a5.501 5.501 0 01-.143-1.247c0-3.023 2.436-5.472 5.44-5.472a5.4 5.4 0 013.965 1.728 10.816 10.816 0 003.451-1.33 5.468 5.468 0 01-2.387 3.028 10.805 10.805 0 003.122-.86 11.103 11.103 0 01-2.713 2.833c.009.233.016.469.016.707 0 7.233-5.47 15.575-15.47 15.575a15.32 15.32 0 01-8.333-2.46c.425.052.859.076 1.299.076 2.544 0 4.889-.873 6.75-2.343a5.442 5.442 0 01-5.077-3.806",
    fill: "#fff"
  })));
}

export default SvgTwitter;